import { ResidentialIncentiveApiData } from '../../../types/ResidentialIncentivesDataType';
import PDFTableColumnConstantsResidential from '../../../constants/PDFTableColumnConstantsResidential';
import styles from '.././ReportPage.module.scss';
import { Link, PageHeader, RowValuesType } from '@cxc/react-fpds-components';
import FordProLogo from '../../Logo/FordProLogo';
import dayjs from 'dayjs';
import Table from '../../Table/Table';

interface PDFReportPageResidentialProps {
    zipcode: string;
    incentives: ResidentialIncentiveApiData[];
}

const PDFReportPageResidential = ({ zipcode, incentives }: PDFReportPageResidentialProps) => {
    const currentDate = new Date();
    const formattedDateTime = dayjs(currentDate).format('DD/MM/YYYY, HH:mm');
    const cellStyle = {
        width: 'Fill 310px',
        height: 'Fill 736px',
        minWidth: '120px',
        gap: '0px',
        opacity: '0px',
    };

    const handleUrlClick = (url: string) => {
        window.open(url, '_blank');
    };

    const generateRowValues = () => {
        const rowValues: RowValuesType = [];
        incentives.forEach((incentive: ResidentialIncentiveApiData) => {
            rowValues.push({
                rowId: incentive.incentiveName,
                cellData: [
                    {
                        leadingComponents: <div style={cellStyle}>{incentive.incentiveName}</div>,
                    },
                    {
                        leadingComponents: <div style={cellStyle}>{incentive.description}</div>,
                    },
                    {
                        leadingComponents: <div style={cellStyle}> {incentive.typicalAmount} </div>,
                    },
                    {
                        leadingComponents: <div style={cellStyle}> {incentive.type} </div>,
                    },
                    {
                        leadingComponents: (
                            <div
                                style={{
                                    ...cellStyle,
                                    overflowWrap: 'anywhere',
                                    whiteSpace: 'pre-wrap',
                                }}
                            >
                                <Link
                                    style={{
                                        cursor: 'pointer',
                                    }}
                                    onClick={() => {
                                        handleUrlClick(incentive.detailsUrl);
                                    }}
                                    size="xsmall"
                                >
                                    {incentive.detailsUrl}
                                </Link>
                            </div>
                        ),
                    },
                ],
            });
        });
        return rowValues;
    };

    return (
        <>
            <div className={styles.headerContainer}>
                <FordProLogo />
                {formattedDateTime}
            </div>
            <PageHeader
                titleProp={{
                    title: 'Public Electrification Incentives - Residential Summary',
                    size: 'extraLarge',
                    headingLevel: 'h1',
                }}
                style={{ backgroundColor: 'transparent', marginBottom: '15px' }}
                description={zipcode}
                bottomStroke={false}
            />
            <Table
                headerValues={PDFTableColumnConstantsResidential}
                rowValues={generateRowValues()}
                paginationProps={{ isPaginationEnabled: false, itemsPerPage: 0 }}
            />
        </>
    );
};

export default PDFReportPageResidential;
